import { useState } from 'react';

import { getCookie } from '@api/HelperAPI';
import { tracking } from '@iwoca/frontend-tracking-library';

import styles from './SpillBanner.module.css';
import { getCountry } from '../../iwIntlProvider/CountryProvider';
import { CloseSVG } from '../../svgComponents/closeSVG/CloseSVG';
import HeartSVG from '../../svgComponents/heartSVG/index';

export const SpillBanner = () => {
    const HIDE_SPILL_BANNER_COOKIE_NAME = 'hideSpillBanner';
    const [hideBanner, setHideBanner] = useState(() => {
        return Boolean(getCookie(HIDE_SPILL_BANNER_COOKIE_NAME) === 'true');
    });

    const country = getCountry();

    if (hideBanner || country === 'DE') return null;

    const handleCloseBanner = () => {
        setHideBanner(true);
        tracking.ampli.spillBannerClosed();

        const FOUR_WEEKS_IN_SECONDS = 60 * 60 * 24 * 28;
        document.cookie = `${HIDE_SPILL_BANNER_COOKIE_NAME}=true;max-age=${FOUR_WEEKS_IN_SECONDS}`;
    };

    return (
        <div role="banner" className={styles.Banner}>
            <div className={styles.bannerContent}>
                <HeartSVG className={styles.heartIcon} />
                <p className={styles.bannerText}>
                    We've partnered with mental health platform Spill. You can
                    claim a free therapy session by clicking{' '}
                    <a
                        href="https://share.hsforms.com/1PpBUXKueSfOc3DkIkgp-1A51s0v"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                        onClick={() => tracking.ampli.spillBannerLinkClicked()}
                    >
                        here
                    </a>{' '}
                    (it's totally confidential and we won't see if you use it)
                </p>
            </div>

            <button
                aria-label="close-spill-banner"
                className={styles.closeIcon}
                onClick={handleCloseBanner}
            >
                <CloseSVG />
            </button>
        </div>
    );
};
